import React from 'react';
import SocialIcons from './SocialIcons';
import { Link } from '@reach/router';

export default () => (
  <footer className="container-fluid black_more">
    <div className="bg-footer">
      <img src="./img/footer-img.jpg" alt="bg-footer" />
    </div>
    <div className="row m-10-hor">
      <div className="col-md-4">
        <div className="footer-col">
          <div className="heading">
            <h2 className="font-weight-bold ">Contact Us</h2>
          </div>
          <div className="content">
            <p>
              Have questions? Our team is here to assist you with expert
              estimating and modeling consultations.
            </p>
          </div>
          <div
            className="link-call"
            onClick={() =>
              window.open('mailto:support@paragons.services', '_self')
            }
          >
            Email at. support@paragons.services
          </div>
        </div>
      </div>
      <div className="col-md-2">
        <div className="footer-col">
          <div className="heading">Services</div>
          <div className="content">
            <Link className="no-style-links" to="/services">
              <div className="link">Estimating Services</div>
            </Link>
            <Link className="no-style-links" to="/service1">
              <div className="link">3D Modeling</div>
            </Link>
            <Link className="no-style-links" to="/service2">
              <div className="link">3D Visualization</div>
            </Link>
          </div>
        </div>
      </div>
      <div className="col-md-2">
        <div className="footer-col">
          <div className="heading">Company</div>
          <div className="content">
            <div className="link">
              <a
                className="no-style-links"
                href="https://careers.paragons.services"
              >
                Careers
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div className="footer-col">
          <div className="heading">Follow Us</div>
          <div className="content">
            <p>
              Stay connected with us on social media for the latest updates,
              industry insights, and company news. Follow us today!
            </p>
            <SocialIcons />
          </div>
        </div>
      </div>
    </div>
    <div className="subfooter">
      <div className="row">
        <div
          className="col-md-12"
          style={{ display: 'flex', justifyContent: 'end' }}
        >
          <div className="content" style={{ marginRight: '3.5rem' }}>
            © Copyrights 2025{' '}
            <span className="font-weight-bold">
              Paragons Engineering Services.
            </span>{' '}
            All rights reserved.
          </div>
        </div>
      </div>
    </div>
  </footer>
);
